type CategoryIdType = DefaultCategoryId | string;

export enum DefaultCategoryId {
  ALL_CONTENT = 'ALL_CONTENT',
  POPULAR_CONTENT = 'POPULAR_CONTENT',
  NEW_CONTENT = 'NEW_CONTENT',
}

export type CategoryItem = {
  id: CategoryIdType;
  name: string;
  subCategories?: CategoryItem[];
};
